module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/azioneTre.03426647.pdf";